<!-- eslint-disable max-len -->
<template>
    <div class="study-FUN">
        <Anchor :id="'top'" />
        <div class="block mb-16">
            <div class="block-title">
                <div class="dot" />
                {{ $t('study.landing.title[2]') }}
            </div>
            <div class="block-content">
                {{ $t('study.landing.content[1]') }}
            </div>
            <ListPagination
                :block-data="FUN"
                :label-open="false"
                :router-name="'StudyFUNItem'"
                :show-data="showData"
            />
        </div>
    </div>
</template>

<script>
import API from '@/api';
import { mapMutations } from 'vuex';
import ListPagination from '@/components/list/ListPagination.vue';

export default {
    components: {
        ListPagination,
    },
    data() {
        return {
            showData: false,
            FUN: {
                items: null,
            },
        };
    },
    watch: {
        $route() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapMutations('mNotification', ['setAlert', 'handleError']),
        async init() {
            try {
                const res = await API.BookReport.PublicList({
                    headers: {
                        'Content-Language': (this.$route.path.split('/')[1] || 'zhTw') === 'en' ? 'en' : 'zhTw',
                    },
                });
                this.FUN.items = res.data.raw;
                this.showData = true;
            } catch (e) {
                this.handleError({
                    message: e || this.$t('alertMessage.getdata-fail'),
                    color: 'error',
                });
            }
        },
    },
};
</script>

<style lang="scss">
.study-FUN{
  .block-content{
    font-size: 16px;
    font-weight: 700;
    line-height: 2;
    text-align: justify;
    letter-spacing: 0.1em;
  }
}
</style>
